// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../../engines/components/BaseComponent";
import BaseStateSprite from "../../../../../engines/components/state/BaseStateSprite";
import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import utilsModel from "../../../../../engines/libs/utilsModel";
import utilsView from "../../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../../BundleResourceConfig";
import UserDataManage from "../../../model/UserDataManage";
import MansionsMemberLayer from "./MansionsMemberLayer";

const {ccclass, property} = cc._decorator;

@ccclass
export default class MansionsMemberItem extends BaseComponent {

    @property(cc.Node)
    sprNew: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelIntimate: cc.Label = null;

	@property({ type: BaseStateSprite, displayName:'' })
	sprIntimate: BaseStateSprite = null;

	@property({ type: cc.Label, displayName:'' })
	labelCosts: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelName: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelTagName: cc.Label = null;

	@property({ type: BaseStateSprite, displayName:'' })
	sprFlag: BaseStateSprite = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprHead: cc.Sprite = null;
    
    private _key = '';
    private bWife = false;
    private _parent: MansionsMemberLayer = null;

    private oriWidth = 0;
    private oriHeight = 0;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        
        this.initUI();
    }

    setData(
        _parent: MansionsMemberLayer
        , bWife: boolean
        , key: string
    ) {
        this._parent = _parent;
        this.bWife = bWife;
        this._key = key;

        if (this.isInit()) {
            this.initUI();
        }
    }

    initUI() {
        if (this.oriWidth == 0) {
            this.oriWidth = this.sprHead.node.width * this.sprHead.node.scaleX;
        }
        if (this.oriHeight == 0) {
            this.oriHeight = this.sprHead.node.height * this.sprHead.node.scaleY;
        }
        let mansionDataManage = UserDataManage.instance.mansionDataManage;
        let wifeDataManage = mansionDataManage.wifeDataManage;
        let childDataManage = mansionDataManage.childDataManage;
        let wifeData = wifeDataManage.wifeData;
        let childData = childDataManage.childData;
        let nName = '';
        let icon = '';
        let costs = 0;
        let flagName = '';
        let intimateName = '';
        let bnew = false;
        if (this.bWife) {
            let csvInfos = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.WIFE, this._key);
            if (!csvInfos) {
                console.error(`未找到wife表格数据 id= ` + this._key);
                return;
            }
            let wife = wifeData.lists.get(this._key);
            nName = csvInfos.real_name;
            icon = csvInfos.icon;
            costs = Number(csvInfos.costs);
            bnew = wife.bNew;
            flagName = '妻';
            intimateName = wifeDataManage.getIntimateInfo(wife.intimacy)?.good_name || '';
        } else {
            let child = childData.lists.get(this._key);
            nName = child.name;
            icon = child.icon;
            costs = child.everyDayCost;
            bnew = child.bNew;

            let wInfo = wifeDataManage.getWifeInfo(child.motherId);
            if (wInfo) {
                intimateName = '母*' + wInfo.real_name;
            }
            if (!utilsModel.isValidNumberValue(nName)) {
                nName = '未取名';
            }
            flagName = child.bBoy ? '子' : '女';
        }

        this.labelTagName.string = flagName;
        this.labelName.string = nName;
        this.sprFlag.setFill(!this.bWife);
        this.labelCosts.string = data_control.getNumberFormat(costs*10000);
        this.sprIntimate.setFill(!this.bWife);
        this.labelIntimate.node.color = this.bWife ? cc.color(0xac, 0x73, 0x8f) : cc.color(0x73, 0x81, 0xac);
        this.sprNew.active = bnew;
        this.labelIntimate.string = intimateName;

        this.refreshIcon(icon);
    }

    refreshIcon(icon: string) {
        this.sprHead.node.active = false;
        let path = 'res/people/' + icon;
       
        getOneBundleByInstant(BUNDLE_SMALL_NAME.mansionBundle).load(path, cc.SpriteFrame
            , (err,imgs:cc.SpriteFrame)=>
            {
                if(err){
                    console.log(err);
                }else{
                    this.sprHead.node.active = true;
                    this.sprHead.spriteFrame = imgs;

                    let scaleX = this.oriWidth / this.sprHead.node.width;
                    let scaleY = this.oriHeight / this.sprHead.node.height;
                    this.sprHead.node.scale = Math.min(scaleX, scaleY);
                }
            }
        );
    }

    onClickTouch() {
        // 播放声音
        O1HD.getManagers().soundMgr.playSound("anNiu");


        if (this.sprNew.active) {
            let mansionDataManage = UserDataManage.instance.mansionDataManage;
            let wifeDataManage = mansionDataManage.wifeDataManage;
            let childDataManage = mansionDataManage.childDataManage;
            let wifeData = wifeDataManage.wifeData;
            let childData = childDataManage.childData;
            if (this.bWife) {
                let wife = wifeData.lists.get(this._key);
                wife.bNew = false;
                wifeData.saveLocalData();
            } else {
                let child = childData.lists.get(this._key);
                child.bNew = false;
                childData.saveLocalData();
            }
            this.sprNew.active = false;
        }

        utilsView.openPopupLayer(
            'prefab/operate/MansionOperateLayer'
            , BUNDLE_SMALL_NAME.mansionBundle
            , null
            , {
                _parent: this
                , _pparent: this._parent
                , bWife: this.bWife
                , key: this._key
            }
        );

    }

    // update (dt) {}
}
